<template>

	<div class="loginBg">
     <div class="tit">
       <!-- <img src="../assets/logo.png" class="logo"> -->
       后台管理
     </div>
		 <div class="loginBox">
        <div class="loginBoxBg">

        </div>
        <div class="loginInputBox">
              <div class="loginContent">
                 <div class="inputTit">登录</div>
                 <!-- <div>
                   <Select v-model="model1" style="width:200px" @on-change='change'>
                           <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                       </Select>
                 </div> -->
                 <div style="margin-top: 30px">
                   <!-- <span>账号：</span> -->

                     <Input prefix="ios-contact" placeholder="输入账号" style="width: auto" class='ipt' v-model="name"/>

                 </div>
                 <div style="margin-top: 30px">
                   <!-- <span>密码：</span> -->

                     <Input type="password" placeholder="输入密码"  class='ipt' style="width: auto"  v-model="pas">
                         <Icon type="md-lock" slot="prefix" />
                     </Input>

                 </div>

                 <div>

                           <Button  @click="login()" class="loginBtn">提交</Button>
                 </div>

              </div>


        </div>

		 </div>


	</div>
</template>

<script>

  export default{
  			created(){  //生命周期里接收参数
// console.log(this.$md5('holle world') )
   sessionStorage.setItem('type' ,'1')
  	},
  	data(){
  		 return {
  			 name:'',
  			 pas:'',
  			 code:'',
  			 show:false,

  			 ad:'',
         list:[{
                        value: '1',
                        label: '泰国'
                    },
                    {
                        value: '2',
                        label: '新加坡'
                    },
                    {
                        value: '3',
                        label: '韩国福利'
                    },
                    {
                        value: '4',
                        label: '越南万合'
                    },
                    {
                        value: '5',
                        label: '澳门金沙'
                    },
                    ],
                    model1: '1'
  			 }
  	},
  	methods:{
  		   login() {
               var params = {
                             name:this.name,
                             pwd:this.pas
                           }
                       console.log(params)


											 sessionStorage.setItem('tgLoginname' ,this.name)

                    	 this.post("apis/mark/login",params).then(res => {
                        	 console.log(res)
                           if(res.status == 1){
  						    this.$Message.success('登录成功');
  						      sessionStorage.setItem('token' ,res.data)

  						 this.$router.push({  //核心语句
  									 path:'/home', //跳转的路径


  					  })


  						}else{
  							  this.$Message.error(res.msg);
  						}
                        }).catch(err => {             //
                          console.log(err)
                        });


                },
      

            }

  }


</script>

<style scoped="scoped">
  html,body{
    height: 100%;
  }
	.loginBg{
		background:#6c63ff ;
    height: 100%;
    width: 100%;
    overflow: hidden;
	}
  .tit{
    width: 1100px;
    margin: 0 auto;

    font-size: 40px;
    margin-top: 60px;
    color: white;
  }
  .logo{
    width: 80px;
    height: 80px;
    vertical-align: middle;
  }
	.loginBox{
		width: 1100px;
		height: 550px;
		margin: 0 auto;
		margin-top: 20px;
		border-radius: 10px;
		background: white;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    align-items: center;
	}
  .loginBoxBg{
    background: url(../assets/loginBg.png) ;
    background-size: 100% 100%;
    width: 635px;
    height: 428px;
    margin:  0 20px;

  }
  .loginInputBox{
    width: 392px;
    height: 404px;
    box-shadow: 0px 4px 24px 0px rgba(0,0,0,0.1);

    }
    .loginContent{
      width: 270px;
      height: 380px;
      margin: 20px auto;
    }
    .loginContent input{
     width: 270px;

    }
    .inputTit{
      font-size: 20px;
      margin: 20px 0;
      border-left: 5px solid #6c63ff;
     padding-left: 20px;
      }
    .loginBtn{
      background: #6c63ff;
      width: 180px;

      text-align: center;
      line-height:32px;
      color: white;
      display: block;
      margin:  0 auto;
      margin-top: 90px;
    }
    .ivu-input{
      height:44px;
      line-height: 44px;
      }
      .ivu-input-prefix i{
         /* line-height: 44px; */
      }
</style>



// WEBPACK FOOTER //
// src/components/login.vue